import { useEffect, useState } from 'react';
import { fetchRecentDonorFeed, type RecentDonorFeedEntry } from '@/lib/recent-donor-feed';

interface UseRecentDonorFeedResult {
  entries: RecentDonorFeedEntry[];
  loading: boolean;
}

export function useRecentDonorFeed(limit = 6, logContext = 'useRecentDonorFeed'): UseRecentDonorFeedResult {
  const [entries, setEntries] = useState<RecentDonorFeedEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async (): Promise<void> => {
      const next = await fetchRecentDonorFeed(limit);
      if (!cancelled) {
        setEntries(next);
        setLoading(false);
      }
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [limit, logContext]);

  return { entries, loading };
}
